export default {
  // view
  title: 'Dados de factoring',
  contact: {
    title: 'Contato de factoring',
    name: 'Nome comercial',
    document: 'CIF',
    residence: 'Residência',
    tradeName: 'Razão social',
    address: {
      title: 'Endereço',
      street: 'Rua',
      postalCode: 'Código postal',
      town: 'Cidade',
      city: 'Província',
      country: 'País'
    },
    registrationData: {
      title: 'Informação de registro',
      book: 'Livro',
      sheet: 'Folha',
      folio: 'Fólio',
      section: 'Seção',
      volume: 'Volume',
      mercantileRegistry: 'Registro mercantil',
      additionalRegistrationData: 'Informação adicional'
    },
    medium: {
      title: 'Dados de contato',
      phone: 'Telefone',
      fax: 'Fax',
      web: 'Site',
      email: 'Email',
      name: 'Nome',
      additionalContactDetails: 'Informação adicional'
    }
  },
  payment: {
    title: 'Dados de pagamento',
    headers: {
      date: 'Data',
      amount: 'Quantidade',
      paymentMethod: 'Forma de pagamento'
    }
  },
  assignmentReference: {
    title: 'Referências da cessão',
    name: 'Texto da cláusula de cessão'
  },
  assignmentDocuments: {
    title: 'Documentos da cessão',
    headers: {
      documentCharacter: 'N. do documento',
      representationIdentity: 'T. de representação',
      documentType: 'T. de documento'
    }
  },
  // invoice register
  invoiceFactoring: {
    introFactoringData: 'Inserir dados de factoring',
    requiredFields: '(*) Campos obrigatórios',
    general: 'Entidade de factoring (Cessionário)',
    registration: 'Informação de registro',
    payment: {
      title: 'Dados de pagamento'
    },
    transferReferences: {
      title: 'Referências da cessão',
      clausuleLabel: 'Texto da cláusula de cessão'
    },
    transferDocuments: {
      title: 'Documentos da cessão',
      headers: {
        documentNature: 'N. do documento',
        representationType: 'T. de representação',
        documentType: 'T. de documento',
        newDocument: 'Novo documento de cessão'
      },
      form: {
        documentNature: 'Natureza do documento',
        representationType: 'Tipo de representação',
        documentType: 'Tipo de documento',
        repository: 'Repositório eletrônico',
        repositoryName: 'Nome do repositório',
        repositoryNameTooltip: '[CGN] Conselho Geral do Notariado, [ROLECE] Registro Oficial de Licitadores e Empresas Classificadas do Estado, [REA] Registro Eletrônico de Procuração, [outros]',
        url: 'URL',
        reference: 'Referência eletrônica'
      }
    },
    paymentData: {
      title: 'Dados de pagamento',
      headers: {
        paymentDate: 'Data',
        amount: 'Valor',
        paymentMethod: 'Meio de pagamento',
        newPayment: 'Novo pagamento'
      },
      form: {
        paymentDate: 'Data do pagamento',
        amount: 'Valor',
        paymentMethod: 'Meio de pagamento',
        accountType: 'Conta',
        ibanCredited: 'IBAN Crédito',
        ibanDebited: 'IBAN Débito'
      }
    }
  }
}